import type { ReactElement } from 'react';

import { STATUS_BADGE, STATUS_LABELS, type FlowCapabilities } from '../types';
import { formatDate } from '@/lib/time';

/** Encabezado del Editor: código, estado del documento y, si ya se firmó, la fecha en
 *  que entra en vigencia. */
export function EditorHeader({ caps }: { caps: FlowCapabilities }): ReactElement {
  const awaiting = caps.currentStatus === 'en_aprobacion' && caps.approvedAt !== null;
  return (
    <>
      <div className="pagehead rise" style={{ marginBottom: 16 }}>
        <div className="grow">
          <h1 style={{ marginBottom: 4 }}>{caps.code}</h1>
          <p className="soft" style={{ fontSize: 13 }}>
            Edición en línea y flujo del ciclo documental.
          </p>
        </div>
        <span
          className={`badge ${STATUS_BADGE[caps.currentStatus]}`}
          style={{ alignSelf: 'center' }}
        >
          {STATUS_LABELS[caps.currentStatus]}
        </span>
      </div>

      {awaiting ? (
        <div className="card rise" role="status" style={{ padding: 16, marginBottom: 16 }}>
          <p style={{ fontSize: 13 }}>
            Aprobado y bloqueado. Entra en vigencia el {formatDate(caps.effectiveDate)}.
          </p>
        </div>
      ) : null}
    </>
  );
}
